// extracted by mini-css-extract-plugin
export default {"zoomModal":"F2-z","image":"G2-z","button":"H2-z","isOverlayShown":"I2-z"};